module.exports = __webpack_public_path__ + "ed380d0e64fcccb7d6c9dfae9b663a9c.svg";